import { Injectable } from '@angular/core';
import { Form, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { NumeroriGjinia, NumeroriLloji, NumeroriRasa, NumeroriShoqerimi } from '@core/enums/numerori.enum';
import { NumeroriConstanst } from '@core/globals/numerori/numerori-constants';
import { NumeroriForCreationDTO } from '@core/interfaces/dto/creation/numerori-for-creation-dto.interface';
import { NumeroriBaza } from '@core/interfaces/models/numerori-baza.interface';
import { NumeroriBazaFormulaService } from './numerori-baza-formula.service';

@Injectable({
  providedIn: 'root'
})
export class NumeroriService {

  constructor(private fb: FormBuilder, private numeroriFormulaService: NumeroriBazaFormulaService) { }


  insertForms(numeroriBaza: NumeroriBaza, form: FormGroup) {
    let formArrays = ['numeroriBaza.numerori']

    for (let i = 0; i < formArrays.length; i++) {
      const formArray = form.get(formArrays[i]) as FormArray;
      this.generateNumeroriForms(formArray);
      numeroriBaza.numerori.forEach((item) => {
        let index = formArray.controls.findIndex(
          (c) =>
            c.get('llojiId')?.value == item.llojiId &&
            c.get('shoqerimiId')?.value == item.shoqerimiId &&
            c.get('gjiniaId')?.value == item.gjiniaId &&
            c.get('rasaId')?.value == item.rasaId &&
            c.get('pershkrimi')?.value == ''
        );
        if (index != -1) {
          formArray.controls[index].get('pershkrimi')!.setValue(item.pershkrimi);
        } else {
          this.addNewLakimi(formArray, item.llojiId, item.shoqerimiId, item.gjiniaId, item.rasaId, item.pershkrimi);
        }
      })
    }
  }

  generateForms(formArray: FormArray) {
    this.generateNumeroriForms(formArray);
  }

  generateFormula(baza: string, numeroriBaza: NumeroriBaza, form: FormGroup) {
    const formArray = form.get('numeroriBaza.numerori') as FormArray;
    this.numeroriFormulaService.generateFormula(baza, numeroriBaza, formArray)
  }

  private generateNumeroriForms(formArray: FormArray) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    for (const nll of NumeroriConstanst.NumeroriLlojiIMirefillte) {
      for (const nsh of NumeroriConstanst.NumeroriShoqerimiMeEmer) {

        const numeroriForm = this.fb.group({
          llojiId: nll.id,
          shoqerimiId: nsh.id,
          gjiniaId: null,
          rasaId: null,
          pershkrimi: ''
        });

        formArray.push(numeroriForm);
      }
    }



    for (const nll of NumeroriConstanst.NumeroriLlojiIMirefillte) {
      for (const nsh of NumeroriConstanst.NumeroriShoqerimiPaEmer) {
        for (const nr of NumeroriConstanst.NumeroriRasa) {
          const numeroriForm2 = this.fb.group({
            llojiId: nll.id,
            shoqerimiId: nsh.id,
            gjiniaId: null,
            rasaId: nr.id,
            pershkrimi: ''
          })

          formArray.push(numeroriForm2);
        }
      }
    }

    for (const nll of NumeroriConstanst.NumeroriLlojiITeresise) {
      for (const nsh of NumeroriConstanst.NumeroriShoqerimiMeEmer) {
        for (const ngj of NumeroriConstanst.NumeroriGjinia) {
          const numeroriForm3 = this.fb.group({
            llojiId: nll.id,
            shoqerimiId: nsh.id,
            gjiniaId: ngj.id,
            rasaId: null,
            pershkrimi: ''
          })

          formArray.push(numeroriForm3);
        }
      }
    }

    for (const nll of NumeroriConstanst.NumeroriLlojiITeresise) {
      for (const nsh of NumeroriConstanst.NumeroriShoqerimiPaEmer) {
        for (const ngj of NumeroriConstanst.NumeroriGjinia) {
          for (const nr of NumeroriConstanst.NumeroriRasa) {
            const numeroriForm4 = this.fb.group({
              llojiId: nll.id,
              shoqerimiId: nsh.id,
              gjiniaId: ngj.id,
              rasaId: nr.id,
              pershkrimi: ''
            })

            formArray.push(numeroriForm4);
          }
        }
      }
    }

    for (const nll of NumeroriConstanst.NumeroriLlojiIMirefillte) {
      for (const nsh of NumeroriConstanst.NumeroriShoqerimiPaEmer) {
        for (const ngj of NumeroriConstanst.NumeroriGjinia) {
          for (const nr of NumeroriConstanst.NumeroriRasa) {
            const numeroriForm5 = this.fb.group({
              llojiId: nll.id,
              shoqerimiId: nsh.id,
              gjiniaId: ngj.id,
              rasaId: nr.id,
              pershkrimi: ''
            })

            formArray.push(numeroriForm5);
          }
        }
      }
    }


    for (const nll of NumeroriConstanst.NumeroriLlojiIMirefillte) {
      for (const nsh of NumeroriConstanst.NumeroriShoqerimiMeEmer) {
        for (const ngj of NumeroriConstanst.NumeroriGjinia) {
          const numeroriForm6 = this.fb.group({
            llojiId: nll.id,
            shoqerimiId: nsh.id,
            gjiniaId: ngj.id,
            rasaId: null,
            pershkrimi: ''
          });

          formArray.push(numeroriForm6);
        }
      }
    }

    for (const nr of NumeroriConstanst.NumeroriRasa) {
      const numeroriForm7 = this.fb.group({
        llojiId: null,
        shoqerimiId: null,
        gjiniaId: null,
        rasaId: nr.id,
        pershkrimi: ''
      });

      formArray.push(numeroriForm7);
    }

    formArray.disable();
  }

  addNewLakimi(formArray: FormArray, lloji: NumeroriLloji, shoqerimi: NumeroriShoqerimi, gjinia?: NumeroriGjinia, rasa?: NumeroriRasa, pershkrimi?: string) {
    const numeroriForm = this.fb.group({
      llojiId: lloji,
      shoqerimiId: shoqerimi,
      gjiniaId: gjinia,
      rasaId: rasa,
      pershkrimi: ''
    });

    formArray.push(numeroriForm);
  }

  getCreationDTO(form: FormGroup) {
    const creationDTO: NumeroriForCreationDTO[] = [];

    let formArray: FormArray;
    formArray = form.get('numeroriBaza.numerori') as FormArray;

    formArray.value.forEach((e: any) => {
      creationDTO.push({
        llojiId: e.llojiId,
        shoqerimiId: e.shoqerimiId,
        gjiniaId: e.gjiniaId,
        rasaId: e.rasaId,
        pershkrimi: e.pershkrimi
      })
    })

    return creationDTO;
  }
}
